/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-promise-executor-return */
import React, { useEffect, useState } from "react";
import { Divider, Modal, Tag, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { useLazyQuery, useQuery } from "@apollo/client";
import useLang from "../../../hooks/useLang";
import { getMobileView } from "../../../redux/slices/isMobile";
import { GET_AI_RESPONSE, GET_USE_CASES } from "../../../graphql/query";

const CloseIconJsx = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M16.0673 15.1832C16.1254 15.2412 16.1714 15.3102 16.2028 15.386C16.2343 15.4619 16.2505 15.5432 16.2505 15.6253C16.2505 15.7075 16.2343 15.7888 16.2028 15.8647C16.1714 15.9405 16.1254 16.0095 16.0673 16.0675C16.0092 16.1256 15.9403 16.1717 15.8644 16.2031C15.7885 16.2345 15.7072 16.2507 15.6251 16.2507C15.543 16.2507 15.4617 16.2345 15.3858 16.2031C15.3099 16.1717 15.241 16.1256 15.1829 16.0675L10.0001 10.8839L4.81729 16.0675C4.70002 16.1848 4.54096 16.2507 4.3751 16.2507C4.20925 16.2507 4.05019 16.1848 3.93292 16.0675C3.81564 15.9503 3.74976 15.7912 3.74976 15.6253C3.74976 15.4595 3.81564 15.3004 3.93292 15.1832L9.11651 10.0003L3.93292 4.81753C3.81564 4.70026 3.74976 4.5412 3.74976 4.37535C3.74976 4.2095 3.81564 4.05044 3.93292 3.93316C4.05019 3.81588 4.20925 3.75 4.3751 3.75C4.54096 3.75 4.70002 3.81588 4.81729 3.93316L10.0001 9.11675L15.1829 3.93316C15.3002 3.81588 15.4593 3.75 15.6251 3.75C15.791 3.75 15.95 3.81588 16.0673 3.93316C16.1846 4.05044 16.2505 4.2095 16.2505 4.37535C16.2505 4.5412 16.1846 4.70026 16.0673 4.81753L10.8837 10.0003L16.0673 15.1832Z"
      fill="#334155"
    />
  </svg>
);

const ConversationSummary = ({
  isDisabled,
  selectedLead,
  user,
  summaryVisible,
  setSummaryVisible,
  flex = true,
}) => {
  const [lang] = useLang();
  const [isShowConversationSummarySection, setIsShowConversationSummarySection] = useState(false);
  const [isSummaryModelOpen, setIsSummaryModelOpen] = useState(false);
  const [conversationSummaryText, setConversationSummaryText] = useState(
    lang.conversationSummaryInProgress
  );

  const [conversationSummaryTags, setConversationSummaryTags] = useState([]);

  const isMobileView = useSelector(state => getMobileView(state));

  useEffect(() => {
    if (isMobileView) {
      setIsShowConversationSummarySection(false);
    } else {
      setIsShowConversationSummarySection(true);
    }
  }, [isMobileView]);

  const { data: useCases } = useQuery(GET_USE_CASES);

  const [getAIResponse] = useLazyQuery(GET_AI_RESPONSE, {
    fetchPolicy: "network-only",
    variables: {
      companyId: +user?.company?.id,
      applicationUseCaseId: +useCases?.getApplicationUseCases?.filter(
        useCase => useCase.code === "ENGAGEMENT_CONVERSATION_SUMMARY"
      )[0]?.id,
      leadId: selectedLead?.id,
      regenerate: summaryVisible && summaryVisible?.count > 1,
      generateTasks: true,
    },
    onCompleted: res => {
      setConversationSummaryText(res?.getAiResponse?.content);
      setConversationSummaryTags(res?.getAiResponse?.futureTasks);
      if (res?.getAiResponse?.statusCode === 200) {
        setConversationSummaryText(res?.getAiResponse?.content);
        setConversationSummaryTags(res?.getAiResponse?.futureTasks);
      } else {
        setConversationSummaryText(lang.ottoAiSummaryFailedText);
        setConversationSummaryTags([]);
      }
    },
    onError: err => {
      console.log("ConversationSummary:getAIResponse::onError:res====>", err);
      setConversationSummaryText(lang.conversationSummaryFailed);
      setConversationSummaryTags([]);
    },
  });

  useEffect(() => {
    setConversationSummaryTags([]);
  }, [summaryVisible && summaryVisible?.count]);

  // Summarize conversation for selected lead
  const summarizeConversation = async () => {
    setConversationSummaryText(lang.conversationSummaryInProgress);
    if (!isShowConversationSummarySection) {
      setIsShowConversationSummarySection(true);
    }
    await getAIResponse();
  };

  useEffect(() => {
    if (!isDisabled) {
      summarizeConversation();
    }
  }, [summaryVisible?.count]);

  return (
    <div className={isMobileView ? "w-full" : "w-full flex-col"}>
      <div className={`${flex && "flex"} items-center`}>
        {isShowConversationSummarySection && (
          <div className="flex flex-col mt-2 p-4 w-full border-[2px] rounded-[4px] border-grey-200 border-solid z-10 bg-white">
            <div className="flex flex-row h-[30px] justify-between">
              <p className="my-1 text-sm text-[#64748B] font-semibold">Conversation Summary</p>
              <CloseIconJsx
                className="cursor-pointer"
                onClick={() => setSummaryVisible({ visible: false, count: 0 })}
              />
            </div>
            <Divider className="m-1 mb-2 border-[2px] border-grey-200" />
            <div>{conversationSummaryText}</div>
            <div className="flex flex-row flex-wrap">
              {conversationSummaryTags?.map((tag, i) => (
                <Tooltip key={`tag_${i}`} title={tag.taskDescription || tag.taskTitle}>
                  <Tag className="mt-2 bg-[#cbd5e1] text-grey-700 rounded-[2px]">
                    <div>{tag.taskTitle}</div>
                  </Tag>
                </Tooltip>
              ))}
            </div>
          </div>
        )}
      </div>
      {isSummaryModelOpen && isMobileView && (
        <Modal
          title={lang.conversationsummery}
          open={isSummaryModelOpen}
          onCancel={() => {
            setIsSummaryModelOpen(false);
            setIsShowConversationSummarySection(false);
          }}
          maskClosable={false}
          footer={null}
        >
          <p>{conversationSummaryText}</p>
          <p>
            {conversationSummaryTags?.map((tag, i) => (
              <Tag key={`tag_${i}`}>
                <span className="table whitespace-normal">{tag.taskTitle}</span>
              </Tag>
            ))}
          </p>
        </Modal>
      )}
    </div>
  );
};

export default ConversationSummary;
